// extracted by mini-css-extract-plugin
export default {"baseWidth":"similarity_baseWidth__wrxnP","fieldWrapper":"similarity_fieldWrapper__dodUF","dropdownSize":"similarity_dropdownSize__587vM"};